import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import Icon from "../elements/icon";

export default class Switch extends React.Component {
  static displayName = "Switch";

  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.any,
    onChange: PropTypes.func,
    defaultChecked: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    showLabel: PropTypes.bool,
  };

  static defaultProps = {
    showLabel: true,
  };

  handleChange = () => {
    let isChecked = this.input.checked;
    if (!_.isUndefined(this.props.defaultChecked)) {
      isChecked = !this.props.checked;
    }
    return typeof this.props.onChange === "function"
      ? this.props.onChange(isChecked, this.props.name, this.props.value)
      : undefined;
  };

  render() {
    return (
      <div className={this.props.className || ""}>
        <div className="et--onoffswitch">
          <input
            type="checkbox"
            className="et--onoffswitch-checkbox"
            id={`${this.props.name}-et--onoffswitch`}
            checked={this.props.checked}
            defaultChecked={this.props.defaultChecked}
            name={this.props.name}
            value={this.props.value}
            disabled={this.props.disabled}
            onClick={this.props.onClick}
            onChange={this.handleChange}
            ref={(e) => {
              this.input = e;
            }}
          />
          <label className="et--onoffswitch-label" htmlFor={`${this.props.name}-et--onoffswitch`}>
            <div
              className="et--onoffswitch-inner"
              tabIndex={this.props.disabled ? undefined : "0"}
              role="checkbox"
              aria-checked={this.props.checked}
              aria-label={this.props.label ? this.props.label : "Select checkbox"}
              onKeyDown={(e) => {
                // on spacebar click
                if (e.key === " ") {
                  this.input.click();
                }
              }}
            />
            <div className="et--onoffswitch-switch">
              {typeof this.props.checked !== "undefined" && (
                <Icon size={1} icon={this.props.checked ? "check" : "clear"} />
              )}
            </div>
          </label>
        </div>
        {this.props.label && this.props.showLabel && (
          <span className="et--onoffswitch--text-label">{this.props.label}</span>
        )}
      </div>
    );
  }
}
